import { crmSystem } from "@/constants/crm/_shared/systems";
import { Configuration } from "@/types/crm/configuration/configuration";
import { airtableDefaultConfiguration } from "./airtable/defaultConfiguration";
import { salesforceDefaultConfiguration } from "./salesforce/defaultConfiguration";
import { collaborateDefaultConfiguration } from "./collaborate/defaultConfiguration";




export const DEFAULT_CONFIGURATION_FOR_CRM_SYSTEM = {
    "airtable": airtableDefaultConfiguration,
    "salesforce": salesforceDefaultConfiguration,
    "collaborate": collaborateDefaultConfiguration,
} satisfies Record<crmSystem, Configuration>